var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVariety(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 327,
    height: 297,
    fill: "none",
    viewBox: "0 0 327 297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M275.905 239.907a9.33 9.33 0 0 0 4.706.386 9.332 9.332 0 0 0 4.292-1.971c3.151-2.646 4.141-7.003 4.943-11.039l2.378-11.935-4.978 3.428c-3.581 2.465-7.241 5.01-9.72 8.581-2.48 3.571-3.562 8.445-1.57 12.309"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M276.324 254.357c-.504-3.671-1.022-7.388-.669-11.098.314-3.294 1.319-6.512 3.366-9.151a15.224 15.224 0 0 1 3.906-3.54c.391-.246.75.373.361.618a14.477 14.477 0 0 0-5.725 6.907c-1.246 3.17-1.446 6.626-1.23 9.993.13 2.037.406 4.059.683 6.08a.373.373 0 0 1-.037.27.373.373 0 0 1-.213.171.358.358 0 0 1-.44-.25h-.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M316.54 254.21s-5.229-12.87 10.456-22.522L316.54 254.21Zm-6.429-.234s-1.594-9.173-13.939-9.095l13.939 9.095Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.195 141.347h114.943v-81.08H21.195v81.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M138.597 143.808H18.734v-86h119.863v86Zm-117.403-2.46h114.943v-81.08H21.194v81.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M11.02 133.898h-.848V51.496h114.946v.854H11.019v81.548Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M.848 124.931H0V42.529h114.946v.854H.848v81.548Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M78.668 125.571c13.577 0 24.583-11.087 24.583-24.763 0-13.676-11.006-24.763-24.583-24.763-13.576 0-24.582 11.087-24.582 24.763 0 13.676 11.006 24.763 24.582 24.763Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M78.664 125.981c-13.78 0-24.992-11.293-24.992-25.173 0-13.88 11.211-25.173 24.992-25.173s24.993 11.292 24.993 25.173c0 13.88-11.212 25.173-24.993 25.173Zm0-49.526c-13.328 0-24.172 10.924-24.172 24.353 0 13.428 10.844 24.353 24.172 24.353 13.33 0 24.173-10.925 24.173-24.353 0-13.429-10.844-24.353-24.173-24.353Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5906",
    d: "M71.867 88.522v24.998l20.397-12.67-20.397-12.328Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB7B7",
    d: "M211.253 249.414h-4.587l-2.182-17.691h6.77l-.001 17.691Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M212.423 253.86h-14.79v-.188a5.756 5.756 0 0 1 5.756-5.756h9.034v5.944Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB7B7",
    d: "m250.655 242.71-3.846 2.5-11.473-13.643 5.676-3.69 9.643 14.833Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "m254.057 245.8-12.4 8.061-.102-.157a5.759 5.759 0 0 1 1.689-7.964l7.573-4.924 3.24 4.984ZM222.968 82.421a4.226 4.226 0 1 0 .001-8.452 4.226 4.226 0 0 0-.001 8.452Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M218.977 79.732a4.232 4.232 0 0 1-.542-4.137 4.223 4.223 0 0 1 3.274-2.588 4.225 4.225 0 1 0 .525 8.4 4.216 4.216 0 0 1-3.257-1.675Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M218.594 105.566c6.857 0 12.415-5.559 12.415-12.415 0-6.856-5.558-12.415-12.415-12.415-6.856 0-12.414 5.559-12.414 12.415 0 6.856 5.558 12.415 12.414 12.415Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M207.022 88.629a12.413 12.413 0 0 1 16.076-6.268c-.126-.063-.25-.127-.378-.186a12.415 12.415 0 0 0-10.36 22.565c.128.059.257.112.387.166a12.41 12.41 0 0 1-5.725-16.277Zm26.636 69.668 8.897 46.154 11.677 34.476-18.906 3.893-18.351-68.953-.556 66.173-23.911.556 5.561-39.482 6.751-44.573 28.838 1.756Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB8B8",
    d: "M218.63 105.479a8.34 8.34 0 0 0 8.341-8.341 8.34 8.34 0 1 0-16.682 0 8.341 8.341 0 0 0 8.341 8.341Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5906",
    d: "m226.428 109.598-12.79.32-8.897 4.449 1.112 25.579-2.156 19.588s-.806 3.07 4.755 5.851c1.779.89 4.071 1.267 6.366 1.368a20.615 20.615 0 0 0 13.064-4.131c1.166-.854 2.459-1.426 3.551-.989 2.78 1.112 3.336-2.224 3.336-2.224l-3.336-16.126 5.005-15.335-5.055-16.461-4.955-1.889Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M210.93 88.416v9.287h2.151l2.737-2.933-.367 2.933h9.507l-.586-2.933 1.173 2.933h1.515v-9.287h-16.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5906",
    d: "M228.727 94.825a1.016 1.016 0 0 0-1.011-.92h-1.021v6.727h1.021a1.015 1.015 0 0 0 1.011-.92A2.395 2.395 0 0 0 230.5 97.4v-.262a2.392 2.392 0 0 0-1.773-2.313Zm-18.443 4.973h-1.128a2.4 2.4 0 0 1-2.398-2.398v-.262a2.407 2.407 0 0 1 .702-1.696 2.402 2.402 0 0 1 1.696-.702h1.128v5.058Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5906",
    d: "M210.565 100.632h-1.021a1.021 1.021 0 0 1-1.021-1.02v-4.687a1.023 1.023 0 0 1 1.021-1.02h1.021v6.727Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5906",
    d: "M228.18 95.092h-.748c0-5.285-3.915-9.584-8.728-9.584-4.814 0-8.729 4.3-8.729 9.584h-.748c0-5.697 4.251-10.332 9.477-10.332 5.225 0 9.476 4.635 9.476 10.332Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB7B7",
    d: "M197.698 173.054a3.514 3.514 0 0 0 1.759-2.391 3.496 3.496 0 0 0-.032-1.52 3.5 3.5 0 0 0-.671-1.364l3.853-7.03-3.702-3.384-5.301 10.005a3.524 3.524 0 0 0-.478 4.66 3.53 3.53 0 0 0 4.572 1.024Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5906",
    d: "m207.516 114.366-1.497-.733s-3.508.733-4.62 2.958c-1.112 2.224-3.892 25.023-3.892 25.023l-2.225 15.014s-1.668 0-1.668 1.668c0 1.669-2.224 6.117-.556 6.117 1.668 0 8.341 0 9.453-1.112s3.337-5.561 2.781-6.117-1.669-.556-1.669-.556l1.565-15.052 2.328-27.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB7B7",
    d: "M237.408 167.829a3.502 3.502 0 0 1-1.097-2.758 3.511 3.511 0 0 1 1.411-2.612l-1.949-7.777 4.437-2.336 2.598 11.02a3.53 3.53 0 0 1-.718 4.63 3.526 3.526 0 0 1-4.682-.167Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5906",
    d: "m231.82 136.655 1.565 15.052s-1.112 0-1.669.556c-.556.556 1.669 5.005 2.781 6.117s7.785 1.112 9.453 1.112c1.668 0-.556-4.448-.556-6.117 0-1.668-1.668-1.668-1.668-1.668l-2.224-15.014s-2.781-20.339-3.893-22.563c-1.112-2.225-4.62-2.958-4.62-2.958l-1.497.733 2.328 24.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "m201.33 167.994-.071.045-1.248-1.966a1.358 1.358 0 0 0-.844-.593 1.35 1.35 0 0 0-1.016.177l-4.166 2.643a1.345 1.345 0 0 0-.416 1.86l6.844 10.787a1.345 1.345 0 0 0 1.86.416l4.166-2.643a1.346 1.346 0 0 0 .416-1.86l-4.708-7.421.071-.046-.888-1.399Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5906",
    d: "m199.769 166.233 6.834 10.771a1.009 1.009 0 0 1-.311 1.389l-4.186 2.656a1.008 1.008 0 0 1-1.389-.311l-6.834-10.771a1.007 1.007 0 0 1 .311-1.389l.508-.322a.476.476 0 0 0 .726.319l2.387-1.514a.486.486 0 0 0 .222-.392.479.479 0 0 0-.201-.402l.544-.345a1.007 1.007 0 0 1 1.389.311Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBCBCB",
    d: "M323.591 254.631H167.387a.41.41 0 0 1 0-.82h156.204a.41.41 0 1 1 0 .82Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 42.53h327v212.101H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariety);
export default __webpack_public_path__ + "static/media/variety.32d7b70a27dcb3262b48f6400b49579d.svg";
export { ForwardRef as ReactComponent };